import {
  CRITEO_ATTRIBUTION_REGEX,
  CRITEO_ATTRIBUTION_SESSION_KEY,
  CRITEO_FREESPEE_BASE_PIXEL_URL,
  CRITEO_FREESPEE_SESSION_ID_SEPARATOR,
  DEFAULT_EVENT_VALUE_FOR_NO_RELEVANT_PROPERTIES,
  IS_CRITEO_ATTRIBUTION_DEDUPLICATION_VALUE,
  IS_NOT_CRITEO_ATTRIBUTION_DEDUPLICATION_VALUE,
  TRACK_EVENTS,
  TRACK_PAGE_EVENTS,
  VENTA_EVENT_RELATED_TO_PRIVATE_SELLER_VALUE,
  VENTA_EVENT_RELATED_TO_PROFESSIONAL_SELLER_VALUE
} from './config.js'

const getCriteoSessionAttribution = () => sessionStorage[CRITEO_ATTRIBUTION_SESSION_KEY] || false

export const getCriteoUrlAttribution = () => {
  const searchParams = window.location.search
  return CRITEO_ATTRIBUTION_REGEX.test(searchParams)
}

const getDeduplication = () => {
  const isCriteo = getCriteoUrlAttribution() || getCriteoSessionAttribution()
  return isCriteo ? IS_CRITEO_ATTRIBUTION_DEDUPLICATION_VALUE : IS_NOT_CRITEO_ATTRIBUTION_DEDUPLICATION_VALUE
}

const getCriteoTrackingIdFromSessionId = ({sessionId}) =>
  sessionId.split(CRITEO_FREESPEE_SESSION_ID_SEPARATOR).slice(0, 1)

export const getCriteoFreespeePixel = ({sessionId}) => {
  const trackingId = getCriteoTrackingIdFromSessionId({sessionId})
  return `${CRITEO_FREESPEE_BASE_PIXEL_URL}${trackingId}`
}

const getRandomId = () => String(Math.floor(Math.random() * 99999999999))

export const getCriteoEventData = ({event, eventData}) => {
  const {adId, adsListAdIds, categoryId, ioId} = eventData
  switch (event) {
    case TRACK_PAGE_EVENTS.AD_INSERTED:
      return {
        extra_concesionario: VENTA_EVENT_RELATED_TO_PRIVATE_SELLER_VALUE,
        id: `pri-${adId}`,
        deduplication: getDeduplication(),
        item: [
          {
            id: categoryId,
            price: DEFAULT_EVENT_VALUE_FOR_NO_RELEVANT_PROPERTIES,
            quantity: DEFAULT_EVENT_VALUE_FOR_NO_RELEVANT_PROPERTIES
          }
        ]
      }
    case TRACK_PAGE_EVENTS.ADS_DETAIL:
      return {item: adId}
    case TRACK_PAGE_EVENTS.ADS_LIST:
      return {item: adsListAdIds}
    case TRACK_PAGE_EVENTS.INSTANT_OFFER_APPOINTMENT_CONFIRMED:
      return {
        extra_concesionario: VENTA_EVENT_RELATED_TO_PROFESSIONAL_SELLER_VALUE,
        id: `pro-${ioId}`,
        deduplication: getDeduplication(),
        item: [
          {
            id: categoryId,
            price: DEFAULT_EVENT_VALUE_FOR_NO_RELEVANT_PROPERTIES,
            quantity: DEFAULT_EVENT_VALUE_FOR_NO_RELEVANT_PROPERTIES
          }
        ]
      }
    case TRACK_PAGE_EVENTS.INSTANT_OFFER_STANDALONE:
      return {
        extra_concesionario: VENTA_EVENT_RELATED_TO_PROFESSIONAL_SELLER_VALUE,
        item: categoryId
      }
    case TRACK_PAGE_EVENTS.PTA_CAR_CATEGORY:
      return {
        extra_concesionario: VENTA_EVENT_RELATED_TO_PRIVATE_SELLER_VALUE,
        item: categoryId
      }
    case TRACK_PAGE_EVENTS.VIEW_INSTANT_OFFER_FROM_STANDALONE:
      return {
        extra_concesionario: VENTA_EVENT_RELATED_TO_PROFESSIONAL_SELLER_VALUE,
        item: [
          {
            id: categoryId,
            price: DEFAULT_EVENT_VALUE_FOR_NO_RELEVANT_PROPERTIES,
            quantity: DEFAULT_EVENT_VALUE_FOR_NO_RELEVANT_PROPERTIES
          }
        ]
      }
    case TRACK_EVENTS.TRACK_TRANSACTION:
      return {
        id: getRandomId(),
        deduplication: getDeduplication(),
        item: [
          {
            id: eventData.adId,
            price: DEFAULT_EVENT_VALUE_FOR_NO_RELEVANT_PROPERTIES,
            quantity: DEFAULT_EVENT_VALUE_FOR_NO_RELEVANT_PROPERTIES
          }
        ]
      }
    case TRACK_EVENTS.VIEW_BASKET:
      return {item: `VIEW_PHONE_${eventData.adId}`}
    case TRACK_EVENTS.ADD_TO_CART:
      return {
        item: [
          {
            id: eventData.adId,
            price: DEFAULT_EVENT_VALUE_FOR_NO_RELEVANT_PROPERTIES,
            quantity: DEFAULT_EVENT_VALUE_FOR_NO_RELEVANT_PROPERTIES
          }
        ]
      }
    default:
      return {}
  }
}
